export default __webpack_public_path__ + "static/media/A0007.7319ce02.png";